export default "__VITE_ASSET__kLUN3AGm__"